/* Cookie bar. Shows to anyone who has not chosen yet, new or returning.
   Fails open: if anything about the consent helper is missing, the bar is
   still shown and the choice is still remembered. */
(function () {
  function start() {
    var bar = document.querySelector('[data-cookie-bar]');
    if (!bar) return;

    var accept = bar.querySelector('[data-cookie-accept]');
    var decline = bar.querySelector('[data-cookie-decline]');

    /* Shopify's draft-preview toolbar is pinned to the bottom of the window,
       so shift up out from under it while previewing. */
    function clearPreviewBar() {
      if (document.getElementById('preview-bar-iframe')) {
        bar.classList.add('is-above-preview-bar');
      }
    }

    function show() {
      bar.hidden = false;
      clearPreviewBar();
      // The toolbar is injected late, so check again shortly after.
      window.setTimeout(clearPreviewBar, 1200);
      window.requestAnimationFrame(function () { bar.classList.add('is-in'); });
    }

    function hide() {
      bar.classList.remove('is-in');
      bar.classList.add('is-out');
      window.setTimeout(function () { bar.hidden = true; }, 450);
    }

    function choose(granted) {
      hide();
      var c = window.AborderConsent;
      if (c) {
        c.save({ preferences: granted, analytics: granted, marketing: granted });
      } else {
        try { window.localStorage.setItem('aborder_cookie_choice_v2', granted ? 'all' : 'essential'); }
        catch (e) {}
      }
    }

    if (accept) accept.addEventListener('click', function () { choose(true); });
    if (decline) decline.addEventListener('click', function () { choose(false); });

    if (window.Shopify && window.Shopify.designMode) { show(); return; }

    // Give the helper a moment to appear, then decide either way.
    var waited = 0;
    (function decide() {
      var c = window.AborderConsent;
      if (c) { c.whenReady(function () { if (!c.hasChosen()) show(); }); return; }
      waited += 100;
      if (waited >= 1500) {
        var seen = null;
        try { seen = window.localStorage.getItem('aborder_cookie_choice_v2'); } catch (e) {}
        if (!seen) show();
        return;
      }
      window.setTimeout(decide, 100);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
